import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'


export type IRmaReasonDTO = {
  value: number
  text: string
  alt_text: string | null
  description: string | null
  selected: boolean
  required_attachment: boolean
  tag_product_ids?: number[] | null
}


export class RmaReasonDTO {
  value: number
  text: string
  altText: string | null
  description: string | null
  selected: boolean
  requiredAttachment: boolean
  tagProductIds: number[] | null

  constructor(data: IRmaReasonDTO) {
    this.value = data.value
    this.text = data.text
    this.altText = data.alt_text
    this.description = data.description
    this.selected = data.selected
    this.requiredAttachment = data.required_attachment
    this.tagProductIds = data.tag_product_ids ?? null
  }
}


const validate = createValidate<IRmaReasonDTO>()

export const parseRmaReasonDTO = (data: unknown): RmaReasonDTO => {
  validateGuard(validate, data, 'rma reason')
  return new RmaReasonDTO(data)
}


const validateList = createValidate<IRmaReasonDTO[]>()

export const parseRmaReasonDTOList = (data: unknown): RmaReasonDTO[] => {
  validateGuard(validateList, data, 'rma reasons')
  return (data as IRmaReasonDTO[]).map(parseRmaReasonDTO)
}
